<template>
  <div class="aside">
    <div class="aside_title text_size_16 text_color_white">期刊查询后台系统</div>
    <el-menu
      :default-active="$route.meta.activePathName"
      @select="onMenuSelect"
      class="my-el-menu-no-border"
      background-color="#31394C"
      text-color="#BCBCBC"
      active-text-color="#FFFFFF">
      <el-menu-item
        v-if="userRole > 1"
        index="users"
        class="menu_item">
        <template slot="title">
          <i class="el-icon-user"></i>
          <span>用户列表</span>
        </template>
      </el-menu-item>
      <el-menu-item
        v-if="userRole > 0"
        index="comments"
        class="menu_item">
        <template slot="title">
          <i class="el-icon-chat-dot-round"></i>
          <span>评论管理</span>
        </template>
      </el-menu-item>
      <el-menu-item
        v-if="userRole > 1"
        index="admins"
        class="menu_item">
        <template slot="title">
          <i class="el-icon-postcard"></i>
          <span>账号管理</span>
        </template>
      </el-menu-item>
      <el-menu-item
        v-if="userRole > 0"
        index="coupons"
        class="menu_item">
        <template slot="title">
          <i class="el-icon-money"></i>
          <span>优惠券管理</span>
        </template>
      </el-menu-item>
      <el-menu-item
        v-if="userRole > 0"
        index="carousel-manage"
        class="menu_item">
        <template slot="title">
          <i class="el-icon-picture-outline"></i>
          <span>轮播图管理</span>
        </template>
      </el-menu-item>
      <el-menu-item
        v-if="userRole > 0"
        index="ranking"
        class="menu_item">
        <template slot="title">
          <i class="el-icon-s-data"></i>
          <span>期刊排名</span>
        </template>
      </el-menu-item>
      <el-submenu index='1' v-if="userRole > 0">
        <template slot="title">
          <i class="el-icon-notebook-2"></i>
          <span>内容管理</span>
        </template>
        <el-menu-item
          index="guide"
          class="menu_item">
          <template slot="title">
            <span>选刊指南</span>
          </template>
        </el-menu-item>
        <el-menu-item
          index="announcement"
          class="menu_item">
          <template slot="title">
            <span>最新公告</span>
          </template>
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
export default {
  computed: {
    // 用户权限
    userRole () {
      // 用户角色, 0-普通用户, 1-管理员, 2-超级管理员
      return this.$store.state.userInfo.userRole
    }
  },
  methods: {
    // 选择某一菜单项
    onMenuSelect (index, indexPath) {
      this.$router.push(`/index/${index}`)
    }
  }
}
</script>
<style lang="scss" scoped>
  .aside {
    flex: none;
    width: 200px;
    height: 100%;
    background-color: $color-primary;
    overflow: hidden;
    .aside_title {
      display: flex;
      align-items: center;
      width: 100%;
      height: 50px;
      margin-bottom: 10px;
      padding-left: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/sidebar/index.vue